export default __webpack_public_path__ + "static/media/VeteranPool.f3a29beb.png";